import { Icon } from '@iconify/react/dist/iconify.js'
import { Box, Typography } from '@mui/material'
import React from 'react'

export const CustomTooltip = ({icon,number}) => {
    return (
        <Box
            sx={{
                backgroundColor: "red.main",
                display:"inline-flex",
                alignItems:"center",
                borderRadius: "50px",
                p: "5px 15px",
                gap: 1,
                ml:2
            
            }}
        >
            <Icon icon="hugeicons:seat-selector" color='#fff'  width="20" height="20" />
            <Typography variant='body2' color='primary.main'>{number}</Typography>

        </Box>
    )
}
